{
  "A negative invoice occurs when a product is downgraded or its billing frequency changes. In such cases, the system generates a credit note for the total negative amount, which is applied to future invoices.": "A negative invoice occurs when a product is downgraded or its billing frequency changes. In such cases, the system generates a credit note for the total negative amount, which is applied to future invoices.",
  "Active Add-ons:": "Active Add-ons:",
  "Add Payment Method": "Add Payment Method",
  "Add and manage your payment methods.": "Add and manage your payment methods.",
  "Address": "Address",
  "Are you sure you want to delete this payment method ?": "Are you sure you want to delete this payment method ?",
  "Available Add-ons:": "Available Add-ons:",
  "Balance": "Balance",
  "Billing Information": "Billing Information",
  "Billing information not found.": "Billing information not found.",
  "Billing information updated successfully.": "Billing information updated successfully.",
  "Can not delete default payment method.": "Can not delete default payment method.",
  "Cancel": "Cancel",
  "Cannot delete the only payment method.": "Cannot delete the only payment method.",
  "Company Name": "Company Name",
  "Credits Applied": "Credits Applied",
  "Current Subscription Details": "Current Subscription Details",
  "Default": "Default",
  "Delete Confirmation": "Delete Confirmation",
  "Delete Payment Method": "Delete Payment Method",
  "Edit Contact Information": "Edit Contact Information",
  "Edit and save your information below.": "Edit and save your information below.",
  "Edit billing information": "Edit billing information",
  "Email Address": "Email Address",
  "Error deleting payment method.": "Error deleting payment method.",
  "Error fetching invoice details.": "Error fetching invoice details.",
  "Error fetching payment link.": "Error fetching payment link.",
  "Error loading billing information for this location.": "Error loading billing information for this location.",
  "Error loading billing information.": "Error loading billing information.",
  "Error setting payment method as default.": "Error setting payment method as default.",
  "Error updating billing information.": "Error updating billing information.",
  "Failed to retrieve payment methods.": "Failed to retrieve payment methods.",
  "Here you can find past and upcoming invoices and manage your billing details.": "Here you can find past and upcoming invoices and manage your billing details.",
  "Invoice Amount": "Invoice Amount",
  "Invoice Date": "Invoice Date",
  "Invoice History": "Invoice History",
  "Invoice Name": "Invoice Name",
  "Invoices & Billing in Settings": "Invoices & Billing in Settings",
  "Locations": "Locations",
  "Make Default Payment Method": "Make Default Payment Method",
  "Name": "Name",
  "New": "New",
  "No Locations": "No Locations",
  "No payment methods available.": "No payment methods available.",
  "Okay": "Okay",
  "Paid": "Paid",
  "Pay": "Pay",
  "Payment Methods": "Payment Methods",
  "Payment link not found.": "Payment link not found.",
  "Payment method deleted successfully.": "Payment method deleted successfully.",
  "Payment method set as default.": "Payment method set as default.",
  "Payments Applied": "Payments Applied",
  "Phone": "Phone",
  "Plan features include:": "Plan features include:",
  "Print Invoice": "Print Invoice",
  "Retry": "Retry",
  "Save": "Save",
  "Select location": "Select location",
  "Status": "Status",
  "Subscription Details": "Subscription Details",
  "There are currently no locations accessible for viewing {{pageTitle}}.": "There are currently no locations accessible for viewing {{pageTitle}}.",
  "Transaction history": "Transaction history",
  "Unable to load subscription details.": "Unable to load subscription details.",
  "Unpaid": "Unpaid",
  "Unpaid invoices": "Unpaid invoices",
  "View and manage your invoice history.": "View and manage your invoice history.",
  "View your Billing information.": "View your Billing information.",
  "{{count}} Locations_one": "{{count}} Locations",
  "{{count}} Locations_other": "{{count}} Locations",
  "“Billing” has been renamed to “Invoices & Billing.”": "“Billing” has been renamed to “Invoices & Billing.”",
  "“Billing” is now “Invoices & Billing” and can be found in Organization Settings.": "“Billing” is now “Invoices & Billing” and can be found in Organization Settings."
}
